import React from 'react';
import { SxProps } from '@mui/system';
import { HEALTHCHECK_CONFIG } from 'domain/shared/employee';
import { HealthcheckStatus } from 'domain/shared/core/dashboard';
import { getStatusByMonths } from '../../utils/getStatusByMonth';

interface EmployeeHealthcheckStatusProps {
  iconSx?: SxProps;
  textSx?: SxProps;
  className?: string;
  style?: React.CSSProperties;
}

const EmployeeHealthcheckStatus: React.FC<EmployeeHealthcheckStatusProps> = ({ iconSx, textSx, className, style }) => {
  return (
    <HealthcheckStatus
      iconSx={iconSx}
      className={className}
      style={style}
      statusConfig={HEALTHCHECK_CONFIG}
      getStatusByMonths={getStatusByMonths}
    />
  );
};

export default EmployeeHealthcheckStatus;
